'use strict';

angular.module('app').factory('SolutionsService', SolutionsService);

SolutionsService.$inject = ['ApiService', 'utilService', 'constants'];

function SolutionsService(ApiService, utilService, constants) {
  return {
    getSolutions(entityId) {
      return ApiService.get(`api/entity/${entityId}/solutions`).then(
        (res) => {
          const { solutions } = res.data;

          const solutionTypeConfig = constants.enums.solutionType;

          return {
            ...res,
            data: {
              solutions,
              solutionTypeFlags: utilService.getFlagsObject(solutionTypeConfig, solutions),
            },
          };
        },
        (err) => {
          return err;
        },
      );
    },
  };
}
